<template>
  <picture
    :id="$vId(this)"
    :class="$style.picture"
  >
    <img
      :id="$vId(this, 'img')"
      :style="imgStyle"
      :src="picture.src"
      :alt="picture.alt"
    >
  </picture>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'FouPicture',

  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    full: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      ratio: 1,
      naturalWidth: null
    }
  },

  computed: {
    picture () {
      return {
        src: this.src,
        alt: this.alt
      }
    },
    imgStyle () {
      const style = {}
      if (!this.full) {
        style['max-width'] = '100%'
      }
      if (this.naturalWidth) {
        style.width = `${this.naturalWidth / this.ratio}px`
      }
      return style
    }
  },

  created () {
    this.ratio = window.devicePixelRatio
  },

  mounted () {
    const el = this.$el.querySelector(`#${this.$vId(this, 'img')}`)
    el.addEventListener('load', () => {
      this.naturalWidth = el.naturalWidth
    }, false)
  }
}
</script>

<style lang="scss" module>
.picture {
  img {
    width: auto;
    height: auto;
  }
}
</style>
